import { t } from '@lingui/core/macro';

import Stack from '@/design_system/Stack';
import { Entity } from '@/models/entity';
import { GeneralTermsAndConditions } from '@/routes/SettingsBeta/SettingsOrganization/sections/Entities/subsections/Entities/components/GeneralTermsAndConditions';
import { Logo } from '@/routes/SettingsBeta/SettingsOrganization/sections/Entities/subsections/Entities/components/Logo';

import { CardSection } from '../../components/CardSection';
import { CustomFields } from '../../components/CustomFields';

export const StoreSection = ({ entity }: { entity: Entity }) => {
  const storeFields = [
    {
      label: t({ id: 'settings.store-info.opening-hours', message: 'Opening Hours' }),
      value: entity.storeConfig?.openingHours || t({ id: '_general.na', message: 'N/A' }),
    },
    {
      label: t({ id: 'settings.store-info.sales-advisors', message: 'Sales Advisors' }),
      value:
        entity.storeConfig?.salesAdvisors?.join(', ') || t({ id: '_general.na', message: 'N/A' }),
    },
  ];

  return (
    <Stack gap="1em">
      <Logo entityId={entity.id} />
      <CardSection
        title={t({ id: 'settings.store-info.label', message: 'Store Information' })}
        fields={storeFields}
      />
      <CustomFields entity={entity} trait="store" />
      <GeneralTermsAndConditions entityId={entity.id} />
    </Stack>
  );
};
